// extracted by mini-css-extract-plugin
export default {"main":"home_main__JEa9x","centralize":"home_centralize__Vp6c-","text":"home_text__Rxb7t","explore":"home_explore__Dlm6x"};